export default __webpack_public_path__ + "static/media/clock (2) 2.fc2044a8.svg";